import React from "react";
import "./image-viewer-modal.css";

function ImageViewerModal(props) {
  const { isVisible, modalImage, closeModal } = props;

  if (!isVisible || !modalImage) return null;

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>
          ✖
        </button>
        <img
          src={modalImage.src}
          alt="Selected Polaroid"
          className="modal-image"
        />
        <p className="modal-caption">{modalImage.caption}</p>
      </div>
    </div>
  );
}

export default ImageViewerModal;
